// La paleta de los segmentos: el slot que manda el catálogo y las clases con las que se pinta.
// Vive junto a la píldora y no en el dominio, porque es presentación.

/** Los 8 colores que el catálogo le puede asignar a un segmento (`COLOR_SLOTS` del mock). */
export type SegmentColorSlot =
    | 'slate'
    | 'sky'
    | 'amber'
    | 'violet'
    | 'emerald'
    | 'teal'
    | 'pink'
    | 'rose';

/** El slot con el que cae un `colorSlot` que el wire mande fuera de la paleta. */
export const FALLBACK_COLOR_SLOT: SegmentColorSlot = 'slate';

/** `.seg-chip.c-*` del mock: fondo suave, texto oscuro, borde intermedio. */
const SEGMENT_TONE_CLASS: Record<SegmentColorSlot, string> = {
    slate: 'border-seg-slate-soft-border bg-seg-slate-soft text-seg-slate',
    sky: 'border-seg-sky-soft-border bg-seg-sky-soft text-seg-sky',
    amber: 'border-seg-amber-soft-border bg-seg-amber-soft text-seg-amber',
    violet: 'border-seg-violet-soft-border bg-seg-violet-soft text-seg-violet',
    emerald: 'border-seg-emerald-soft-border bg-seg-emerald-soft text-seg-emerald',
    teal: 'border-seg-teal-soft-border bg-seg-teal-soft text-seg-teal',
    pink: 'border-seg-pink-soft-border bg-seg-pink-soft text-seg-pink',
    rose: 'border-seg-rose-soft-border bg-seg-rose-soft text-seg-rose',
};

/** El punto del chip, saturado: no lleva texto encima, así que no se oscurece. */
const SEGMENT_DOT_TONE_CLASS: Record<SegmentColorSlot, string> = {
    slate: 'bg-seg-slate-dot',
    sky: 'bg-seg-sky-dot',
    amber: 'bg-seg-amber-dot',
    violet: 'bg-seg-violet-dot',
    emerald: 'bg-seg-emerald-dot',
    teal: 'bg-seg-teal-dot',
    pink: 'bg-seg-pink-dot',
    rose: 'bg-seg-rose-dot',
};

/** El slot con red de seguridad: el wire puede mandar uno que esta paleta todavía no conoce. */
export function toKnownColorSlot(slot: SegmentColorSlot): SegmentColorSlot {
    return slot in SEGMENT_TONE_CLASS ? slot : FALLBACK_COLOR_SLOT;
}

export function segmentToneClass(slot: SegmentColorSlot): string {
    return SEGMENT_TONE_CLASS[toKnownColorSlot(slot)];
}

export function segmentDotToneClass(slot: SegmentColorSlot): string {
    return SEGMENT_DOT_TONE_CLASS[toKnownColorSlot(slot)];
}
